
import { TokenLogout } from 'API/Logout/logout';
import axios from 'axios';


const url = process.env.REACT_APP_POST_APPROVAL_URL
export const getConfigData=async(setData)=>{
    try {
        const res = await axios.get(`${url}/products/all`,{
            headers:{
                Authorization:`Bearer ${sessionStorage.getItem('token')}`
            }
        });
        const configData = res.data;
        setData(configData);
    } catch (err) {
        // console.log(err);
        TokenLogout(err)
    }
}

export const DownloadConfigFile=async()=>{
    try {
        const res = await axios.get(`${url}/products`, {
          headers: {
            Authorization:`Bearer ${sessionStorage.getItem('token')}`
          }
        });
        const configData = res.data;
        const configString = `${JSON.stringify(configData, null, 2)}`;
        const blob = new Blob([configString], { type: 'application/json' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'config.json';
        a.click();
        URL.revokeObjectURL(url);
      } catch (err) {
        console.log(err);
      }
}

export const getConfigFile=async(setData)=>{
    try {
        await axios.get('/config.json')
        .then(res=>{
            setData(res.data)
        })
    } catch (error) {
        // console.log(error);
        TokenLogout(error)
    }
}

export const getConfigDataProductID=async(Id,setProduct)=>{
    try {
        const res = await axios.post(`${url}/products/product`,{product_id: Id},{
            headers:{
                Authorization:`Bearer ${sessionStorage.getItem('token')}`
            }
        });
        const configData = res.data;
        setProduct(configData);
    } catch (err) {
        TokenLogout(err)
    }
}